module.exports = __webpack_public_path__ + "static/img/index-carousel-03-01.52cdb8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-carousel-03-01.png
// module id = MdyZ
// module chunks = 0